export default __webpack_public_path__ + "static/calidad-del-mercado-laboral-large-e4d21d4d26e8c5a42d56a2f9ce9fa5a2.svg";